module.exports = __webpack_public_path__ + "img/success-svg.67820cbf.svg";